const features = [
  {
    icon: "ri-shield-keyhole-line",
    title: "Military-Grade Encryption",
    description:
      "Our VPN employs AES-256-GCM encryption, the same standard used by governments and financial institutions worldwide, ensuring your data remains completely private.",
    wide: true,
    img: "https://public.readdy.ai/ai/img_res/882c4cfefa85daa4f6b84332c1d68156.jpg",
  },
  {
    icon: "ri-cpu-line",
    title: "Low Resource Usage",
    description:
      "Intelligent background processing that never drains your battery or slows your device.",
    wide: false,
    img: null,
  },
  {
    icon: "ri-speed-line",
    title: "Blazing Fast Speeds",
    description:
      "Optimized network protocols ensure you never feel the overhead of protection.",
    wide: false,
    img: null,
  },
  {
    icon: "ri-scan-2-line",
    title: "Deep Storage Scanning",
    description:
      "Cleaner Pro&apos;s advanced scanner finds hidden junk, temporary files, and duplicate media that iOS&apos;s native tools miss — recovering gigabytes of storage in minutes.",
    wide: false,
    img: null,
  },
  {
    icon: "ri-lock-password-line",
    title: "Zero-Log Architecture",
    description:
      "We never store, monitor, or log any user activity — your browsing history is yours alone.",
    wide: false,
    img: null,
  },
  {
    icon: "ri-smartphone-line",
    title: "Native iOS Integration",
    description:
      "Deeply integrated with iOS system APIs, offering seamless performance, widget support, and Siri shortcuts.",
    wide: false,
    img: null,
  },
];

export default function FeaturesSection() {
  const wideFeature = features[0];
  const gridFeatures = features.slice(1);

  return (
    <section id="features" className="w-full bg-[#F8F9FA] py-24 md:py-32">
      <div className="w-full px-6 md:px-20">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <span className="text-xs font-semibold tracking-[0.3em] uppercase text-gray-400 bg-gray-200 rounded-full px-4 py-1.5">
              Platform Features
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-none tracking-tight mt-6">
              <span className="block">Why Choose</span>
              <span className="block mt-1">MEDEST?</span>
            </h2>
          </div>
          <p className="text-gray-400 font-light max-w-sm text-sm md:text-base leading-relaxed mb-1">
            Every feature is engineered with precision, tested rigorously, and
            refined based on real user feedback from the iOS community.
          </p>
        </div>

        {/* Wide feature card */}
        <div className="rounded-3xl overflow-hidden bg-white mb-5">
          <div className="flex flex-col lg:flex-row">
            <div className="lg:w-[55%] h-[260px] lg:h-auto overflow-hidden">
              <img
                src={wideFeature.img!}
                alt={wideFeature.title}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex-1 p-8 md:p-12 flex flex-col justify-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-emerald-50 mb-5">
                <i className={`${wideFeature.icon} text-2xl text-emerald-700`}></i>
              </div>
              <h3 className="text-2xl md:text-3xl font-black text-gray-900">{wideFeature.title}</h3>
              <p className="text-gray-500 text-sm md:text-base font-light leading-relaxed mt-4 max-w-md">
                {wideFeature.description}
              </p>
              <div className="mt-6 flex flex-wrap gap-2">
                {["AES-256-GCM", "ChaCha20", "IKEv2/IPSec", "WireGuard"].map((tech) => (
                  <span
                    key={tech}
                    className="text-xs font-semibold text-emerald-700 bg-emerald-50 rounded-full px-3 py-1 tracking-wide"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Grid features */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {gridFeatures.map((feature) => (
            <div
              key={feature.title}
              className="rounded-2xl bg-white p-7 flex flex-col"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-gray-50 mb-5">
                <i className={`${feature.icon} text-xl text-gray-700`}></i>
              </div>
              <h3 className="text-lg font-black text-gray-900">{feature.title}</h3>
              <p className="text-gray-500 text-sm font-light leading-relaxed mt-3">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom showcase */}
        <div
          className="mt-5 rounded-3xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8"
          style={{ background: "linear-gradient(135deg, #0a2e2a 0%, #0d3d34 100%)" }}
        >
          <div className="flex-1">
            <p className="text-white/50 text-xs tracking-widest uppercase mb-3">Performance Benchmark</p>
            <h3 className="text-2xl md:text-3xl font-black text-white leading-tight">
              Industry-leading performance<br />without compromise.
            </h3>
            <p className="text-white/60 text-sm font-light mt-4 leading-relaxed max-w-md">
              Independent benchmarks consistently place our applications in the top 1% of the App Store
              for performance efficiency, security depth, and user satisfaction.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}
